export const DEFAULT_POST_COMPOSER_STEP_DESCRIPTION =
  "We'll post these details with each video. You can pull information from your RSS feed, such as episode titles, to make each post unique.";
